import Link from 'next/link'

import NavTextNodes from '@data/i18n/nav.json'

type Props = {
	topic: string | null
	featuredTopics: any[]
}

function MagazineTopicsNav({ topic, featuredTopics }: Props) {
	return (
		<nav aria-label="Magazine topics" className="border-y sticky top-16 md:top-20 z-20 bg-white">
			<div className="container overflow-x-auto scrollbar">
				<ul className="flex justify-between whitespace-nowrap py-2 max-lg:pb-1 max-md:text-sm">
					<li>
						<Link legacyBehavior href={NavTextNodes.theMagUrl} scroll={false}>
							<a
								className={`px-6 py-4 block bottom-line-current ${
									!topic ? 'current font-medium' : ''
								}`}
							>
								All Stories
							</a>
						</Link>
					</li>

					{featuredTopics.map((topicObj: any) => {
						const { id, uid, data } = topicObj?.topic || {}
						const topicTitle = data?.title?.[0]?.text as string

						return topicTitle && uid ? (
							<li key={id}>
								<Link legacyBehavior href={`${NavTextNodes.theMagUrl}/${uid}`} scroll={false}>
									<a
										className={`p-4 md:px-6 block bottom-line-current ${
											topic === uid ? 'current font-medium' : ''
										}`}
									>
										{topicTitle}
									</a>
								</Link>
							</li>
						) : null
					})}
				</ul>
			</div>
		</nav>
	)
}

export default MagazineTopicsNav
